import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  TASK_TAG_LIST: 'task-tag'
}

const routes = [
  {
    path: 'tag/',
    name: ROUTES.TASK_TAG_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['tasks_tasktag_list'],
      requiresAuth: true
    },
    component: () => import('./TaskTagList.vue')
  }
]

export { routes, ROUTES }
